import { msg } from 'gt-react';
import { Action, Subject } from '@erp/authz';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../../../route';

/**
 * A review comment thread's link (a mention notification's, GEN-3329): finds
 * the thread's review and opens it on the thread's cell.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/item-master/review-threads/$threadId',
  staticData: {
    app: {
      access: {
        featureFlag: 'item-master-ui-enabled',
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Product }],
      },
    },
  },
  component: lazyRouteComponent(
    () => import('../../ReviewThreadLinkPage'),
    'ReviewThreadLinkPage',
  ),
  loader: () => ({
    crumb: msg('Reviews', { context: 'page breadcrumb' }),
  }),
});
